import logo from './logo.svg';
import './App.css';

import { ViewLevel } from './Constants';
import Goal from './components/Goal';
import KeyResult from './components/KeyResult';
import ProgressBar from './components/ProgessBar';
import Task from './components/Task';

import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';

function App(props) {
    const [data, setData] = useState({goals: [], objectives: [], keyResults: [], tasks: [], publicDashboardMessage: '', doNotShowNotes: false, years: ''});
    const [searchParams, setSearchParams] = useSearchParams();

    const yearParam = searchParams.get("y") || "all";
    const year = data.years.indexOf(yearParam) >= 0 ? yearParam : "all";
    const selectedObjectiveId = searchParams.get("o");
    const selectedKeyResultId = searchParams.get("k");
    const viewLevel = Number.parseInt(searchParams.get("v")) || ViewLevel.GoalsAndObjectives;

    //Retrieve the strategic plan data from S3 on page load.
    useEffect(() => {
        fetch("https://yoto-strategic-plan.sfo3.digitaloceanspaces.com/data.json")
        .then((response) => response.json())
        .then((json) => setData(json))
        .catch((err) => console.error(`Error retrieving strategic plan data: ${err.toString()}`));
    }, []);

    const yearDisplayText =
        year === "all"
        ? "All Years"
        : "FY" + year;

    const overallPercentComplete =
    data.overallCompletion
    ? Math.floor(data.overallCompletion[year].percentComplete / data.overallCompletion[year].weight)
    : "n/a";

    //Objectives are grouped in with goals because they are A) always shown together and B) an Objective has only one Goal.
    const goals = data.goals.sort((a,b) => a.sortOrder - b.sortOrder).filter((goal) => !goal.doNotShow).map((goal) => 
        <Goal key={goal.id} data={goal} year={year} viewLevel={viewLevel}
            objectives={data.objectives.sort((a,b) => a.sortOrder - b.sortOrder).filter((objective) => !objective.doNotShow && objective.goalId === goal.id)} />
    );

    const keyResults = 
        viewLevel >= ViewLevel.KeyResults
        ? data.keyResults
            .sort((a,b) => a.sortOrder - b.sortOrder)
            .filter((keyResult) => 
                (keyResult.year === year || year === "all")
                && (keyResult.objectiveId === parseInt(selectedObjectiveId))
                && !keyResult.doNotShow
            ).map((keyResult) => <KeyResult key={keyResult.id} data={keyResult} year={year} viewLevel={viewLevel} doNotShowNotes={data.doNotShowNotes}/>)
        : [];

    const tasks = 
        /*viewLevel >= ViewLevel.Tasks
        ? data.tasks
            .filter((task) => 
                (task.year === year || year === "all")
                && (task.objectiveId === selectedObjectiveId)
                && (task.keyResultId === selectedKeyResultId)
            ).map((task) => <Task key={task.id} data={task} />)
        :*/ [];

    //Scroll the main element to the appropriate position based on the URL parameters.
    useEffect(() => {
        const main = document.getElementsByTagName("main")[0];
        if (main) {
            if (selectedKeyResultId) {
                main.style.left = "-200vw";
            }
            else if (selectedObjectiveId) {
                main.style.left = "-100vw";
            }
            else {
                main.style.left = "0";
            }
        }    
    }, [selectedKeyResultId, selectedObjectiveId]);
    
    return (
        <>
            <header>
                YOTO Strategic Plan
                <div className="subtitle">{yearDisplayText}</div>
            </header>
            <nav>
                <Link to={`/?v=${viewLevel}`}>All Years</Link>
                { data.years.split(',').map((year) => <Link to={`/?y=${year}&v=${viewLevel}`}>{year}</Link>) }
            </nav>
            <div className="dashboard-section" id="public-dashboard-message">
                {data.publicDashboardMessage}
            </div>
            <div className="dashboard-section" id="overall-completion">
                <header>Strategic plan completion for {yearDisplayText}</header>
                <ProgressBar percentComplete={overallPercentComplete} />
            </div>
            <main>
                <div id="goals">
                    <header className="dashboard-section-header">Goals and Objectives</header>
                    {goals}
                </div>
                <div id="key-results">
                    <header className="dashboard-section-header">
                        <Link className="back" to={`/?y=${year}&v=${viewLevel}`}>❮</Link>
                        Key Results
                    </header>
                    {keyResults}
                </div>
                <div id="tasks">
                    <header className="dashboard-section-header">
                        <Link className="back" to={`/?y=${year}&o=${selectedObjectiveId}&v=${viewLevel}`}>❮</Link>
                        Tasks
                    </header>
                    {tasks}
                </div>
            </main>
        </>
    );
}

export default App;
